import React from 'react';

const fotoFrota = process.env.PUBLIC_URL + '/img/cel-transp.webp';

export default function QuemSomos() {
  return (
    <section id="quem-somos">
      <div className="container quemsomos-grid">
        <div className="quemsomos-text">
          <div className="eyebrow">Quem somos</div>
          <h2>A Nivocar é a infraestrutura completa para empresas de rastreamento veicular.</h2>
          <p>Mais do que uma plataforma, entregamos um ecossistema completo para quem deseja criar, expandir ou profissionalizar sua operação. Nossa solução reúne tecnologia, gestão financeira, aplicativos, monitoramento, equipamentos e suporte especializado em um único lugar.</p>
          <p>Com a Nivocar, nossos parceiros têm acesso a uma plataforma <strong>White Label</strong>, aplicativos para Android e iOS, <strong>PortalPay</strong> com integração ao Asaas para cobranças e assinaturas recorrentes, além de rastreadores, chips M2M e uma loja exclusiva para aquisição de equipamentos homologados.</p>
          <p>Acreditamos que empreender no mercado de rastreamento deve ser simples. Por isso, fornecemos toda a infraestrutura necessária para que nossos parceiros possam focar no que realmente importa: conquistar clientes, crescer e construir um negócio sólido, contando sempre com uma tecnologia confiável e em constante evolução.</p>
        </div>
        <div className="quemsomos-foto">
          <img src={fotoFrota} alt="Frota de veículos rastreados e telas do sistema em laptop, tablet e celular" />
        </div>
      </div>
    </section>
  );
}
